import React, { useEffect } from 'react';
import PreviousNext from './PreviousNext';

const PortfolioEntertainment = ({handleMenuClick, project, previous, next}) => {
  useEffect(() => {
    window.scrollTo(0, 0); // scrolls to top when component mounts
  }, []);
  
  return (
    <>
      <main>
          <section id="description">
            <img src={project.preview1}/>
            
            <article>
              <div>
                <h2>
                  {project.title}
                </h2>
                
                
                <p id="descriptiontext1" className="body2 opacity80">
                  {project.description}
                </p>
                
                <p>
                  {project.type}<br/>
                
                  {project.designedWith}
                </p>
                
                <a href="entertainment/index.html" target="_self" rel="noopener">
                  <button className="btn-snormal" onClick={handleMenuClick}>
                    VISIT WEBSITE
                  </button>
                </a>
              </div>
              
              <p id="descriptiontext2"className="body2 opacity80">
                  This project was built in HTML, CSS and JavaScript. I had mobile and desktop designs to work to and 
                  built it so that it was fully-responsive. I took a mobile-first approach and used modern 
                  CSS like Flexbox for layout purposes.
              </p>
            </article>
          </section>
          
          <section id="background">
            <h3>
              Project Background
            </h3>
            
            <p className="body2 opacity80">    
              {project.bio}
            </p> 
          </section>
          
          <section id="previews">
            <h3>
              Static Previews
            </h3>
            
            <div>      
              <img src={project.image}/>
              
              <img src={project.preview2}/>
            </div>
          </section>
      </main>
        
        <PreviousNext handleMenuClick={handleMenuClick} previous={previous} next={next} />
    </>
  );
}

export default PortfolioEntertainment;